export const pricingTranslations = {
    en: {
        title: 'Pricing? Huh, it\'s free',
        subtitle: 'Free for the first 100,000 entrepreneurs. No hidden fees.',
        tiers: {
            free: {
                name: 'Free',
                price: '€0',
                description: 'Free for the first 100,000 entrepreneurs',
                features: [
                    'Instant invoicing',
                    'Recurring invoices',
                    'Auto payment status',
                    'All payment methods',
                    'Internationalisation',
                    'Access for your accountant (Soon)',
                ],
                cta: 'Just Start'
            },
            business: {
                name: 'Big Business',
                price: 'Custom',
                description: 'For growing businesses with advanced needs',
                features: [
                    'Everything in Free, plus',
                    '3 seats or more',
                    '500+ invoices per month',
                    'API access (Soon)',
                ],
                cta: 'Contact Us'
            }
        }
    },
    nl: {
        title: 'Prijzen? Huh, het is gratis',
        subtitle: 'Gratis voor de eerste 100.000 ondernemers. Geen verborgen kosten.',
        tiers: {
            free: {
                name: 'Gratis',
                price: '€0',
                description: 'Gratis voor de eerste 100.000 ondernemers',
                features: [
                    'Direct factureren',
                    'Terugkerende facturen',
                    'Automatische betalingsstatus',
                    'Alle betaalmethoden',
                    'Internationalisatie',
                    'Toegang voor je accountant (Binnenkort)',
                ],
                cta: 'Begin Direct'
            },
            business: {
                name: 'Groot Bedrijf',
                price: 'Op maat',
                description: 'Voor groeiende bedrijven met geavanceerde behoeften',
                features: [
                    'Alles in Gratis, plus',
                    '3 of meer gebruikers',
                    '500+ facturen per maand',
                    'API-toegang (Binnenkort)',
                ],
                cta: 'Neem Contact Op'
            }
        }
    }
}; 